<template lang="html">
  <div class="resume">
    <section class="printBreakAfter">
      <h2 class="sectionTitle">{{ $t('meta.title') }}</h2>
      <img src="@/assets/img/me.jpg" class="profile" />
      <Info
          :items="getEntries('personal.entries')"
          :title="$t('personal.title')" table="table" />
      <Info class="print-only"
          :items="getEntries('meta.contact.entries')"
          :title="$t('meta.contact.title')" table="table" />
      <Info
          :items="getEntries('education.entries')"
          :title="$t('education.title')" table="table" />
      <Info
          :items="getEntries('meta.skills.entries')"
          :title="$t('meta.skills.title')" />
      <Info
          :items="getEntries('meta.languages.entries')"
          :title="$t('meta.languages.title')" table="table" />
    </section>
    <section>
      <h2 class="sectionTitle">{{ $t('employment.title') }}</h2>
      <Job v-for="job in jobs"
          :key="job.id"
          :position="job.position.value"
          :at="other.at"
          :employer="job.employer.value"
          :start="job.duration.start.value"
          :end="job.duration.end.value"
          :link="job.website.value"
          :text="job.description.value"
          :keywords="job.keywords" />
    </section>
  </div>
</template>

<script>
import Info from './Info.vue';
import Job from './Job.vue';

export default {
  name: 'Resume',
  data() {
    return {
      table: true,
    };
  },
  components: {
    Info,
    Job,
  },
  computed: {
    jobs() {
      return this.$i18n.t('employment.jobs');
    },
    other() {
      return this.$i18n.t('employment.other');
    },
  },
  methods: {
    getEntries(x) {
      return Object.values(this.$i18n.t(`${x}`));
    },
  },
};
</script>

<style lang="scss" scoped>
.resume {
  @include respond-to('tablet') {
    @include xCols(2);
  }
  @media print {
    @include xCols(2)
  }
  .profile {
    width: 140px;
    margin-bottom: ms(1);
    border-radius: 6px;
  }
}

.sectionTitle {
  margin-bottom: ms(2);
  @include underline($primary, solid, 2px, 4px);
  @include respond-to('tablet') {
    border: none;
  }
}
.breakAfter {
  page-break-after: always;
}
</style>
